import { render } from "./DetalharUsuario.vue?vue&type=template&id=3bf63178&scoped=true"
import script from "./DetalharUsuario.vue?vue&type=script&lang=js"
export * from "./DetalharUsuario.vue?vue&type=script&lang=js"

import "./DetalharUsuario.vue?vue&type=style&index=0&id=3bf63178&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf63178"]])

export default __exports__